import { Input, type InputProps } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { useState } from 'react'
import { useController, type UseControllerProps, useFormContext } from 'react-hook-form'

import content from 'prismic-translates/loginpage.json'

import Adornment from './Adornment'
import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

export type FormPasswordFieldProps = {
  ignoreErrorMessage?: boolean
  rules?: UseControllerProps['rules']
  name: string
  withHint?: boolean
}

export function FormPasswordField(props: FormPasswordFieldProps & InputProps) {
  const { control } = useFormContext()
  const { withHint = true, ...rest } = props

  const {
    field,
    fieldState: { error, isTouched },
  } = useController({
    name: props.name,
    control,
    rules: props.rules || {},
  })

  const [togglePass, setTogglePass] = useState(false)

  const hasError = isTouched && error
  const hintText = withHint && !isTouched ? t('pass_validation_description') : ''
  const helperText = hasError ? error?.message : hintText

  return (
    <Input
      {...rest}
      error={!!(error && isTouched)}
      className={props.className}
      placeholder={props.placeholder || t('password')}
      value={field.value}
      inputRef={field.ref}
      onChange={field.onChange}
      onBlur={field.onBlur}
      id={props.name}
      name={props.name}
      type={togglePass ? 'text' : 'password'}
      endAdornment={
        <>
          <Adornment togglePass={togglePass} setTogglePass={setTogglePass} />
        </>
      }
      data-test={props.name}
      helperText={props.ignoreErrorMessage ? null : helperText}
      classHelperText={!hasError ? classes.validationText : undefined}
      variant={props.variant}
      aria-label={props.placeholder || t('password')}
      aria-required={true}
    />
  )
}
